import React from "react";
import { motion } from "framer-motion";
import { fadeUp } from "../../animations/variants";

import { useSelector } from "react-redux";
import { servicesText } from "../../i18n/service";

const Services = () => {
  const lang = useSelector((state) => state.language.lang);
  const t = servicesText[lang];

  // 🔥 Smooth scroll handler
  const scrollToContact = () => {
    const section = document.querySelector("#contact");
    if (section) {
      section.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <div className="py-24 bg-darkbg px-6 overflow-hidden">
      {/* HEADING */}
      <motion.h2
        variants={fadeUp}
        initial="hidden"
        whileInView="show"
        viewport={{ once: true }}
        className="text-4xl font-heading text-center text-yellow"
      >
        {t.heading}
      </motion.h2>

      {/* SERVICE CARDS */}
      <div className="max-w-6xl mx-auto grid md:grid-cols-3 gap-10 mt-16">
        {t.services.map((service, i) => (
          <motion.div
            key={i}
            variants={fadeUp}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true }}
            transition={{ delay: i * 0.2 }}
            onClick={scrollToContact}
            className="
              bg-navy p-10 rounded-2xl shadow-xl cursor-pointer
              hover:shadow-2xl border border-gray-800 hover:border-gray-600 
              transition-all duration-300
            "
          >
            {/* TITLE */}
            <h3 className="text-2xl font-heading text-neonYellow animate-neonFlicker">
              {service.title}
            </h3>

            {/* LIST */}
            <ul className="mt-6 space-y-3 text-gray-300 leading-relaxed">
              {service.desc.map((item, j) => (
                <li key={j} className="flex items-start gap-2">
                  <span className="text-yellow mt-0">•</span>
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default Services;
